// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Style css*/

/*Button Exporter*/
.my-custom-class.Exporter {
  background-color: #343a40;
  color: white;
}

/*Button ajouter*/
.my-custom-class.Ajouter {
  background-color: #848687;
  color: white;
}

/*Pagination*/
.table-container {
  position: relative;
}
.table-container .pagination {
  position: absolute;
  right: 0;
  padding-right: 8px;
}

.pagination a {
  color: black;
  padding: 8px 16px;
  text-decoration: none;
}
.pagination a:hover {
  color: black;
}

.page-item.active .page-link {
  background-color: #343a40;
  border-color: #343a40;
  text-decoration: none;
}

.page-link:focus {
  box-shadow: none;
}

/*export button + search*/
.input-container {
  display: flex;
  align-items: center;
}

input[type="date"] {
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/utils/Css/Marketing.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["/*Style css*/\n\n/*Button Exporter*/\n.my-custom-class.Exporter {\n  background-color: #343a40;\n  color: white;\n}\n\n/*Button ajouter*/\n.my-custom-class.Ajouter {\n  background-color: #848687;\n  color: white;\n}\n\n/*Pagination*/\n.table-container {\n  position: relative;\n}\n.table-container .pagination {\n  position: absolute;\n  right: 0;\n  padding-right: 8px;\n}\n\n.pagination a {\n  color: black;\n  padding: 8px 16px;\n  text-decoration: none;\n}\n.pagination a:hover {\n  color: black;\n}\n\n.page-item.active .page-link {\n  background-color: #343a40;\n  border-color: #343a40;\n  text-decoration: none;\n}\n\n.page-link:focus {\n  box-shadow: none;\n}\n\n/*export button + search*/\n.input-container {\n  display: flex;\n  align-items: center;\n}\n\ninput[type=\"date\"] {\n  font-size: 1rem;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
